module.exports = __webpack_public_path__ + "img/calendar-plus.9da2021d.svg";